var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-raiting"},[_c('div',{staticClass:"raiting"},_vm._l((5),function(mark,index){return _c('div',{key:index,staticClass:"star",class:[{ active: _vm.value - 1 >= index }],on:{"click":function($event){return _vm.edit(mark)}}},[_c('icon-star')],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }